import { Component, OnInit, Input } from '@angular/core';
import { Product } from 'src/app/models/virtual-store/product.model';
import { Router, ActivatedRoute } from '@angular/router';
import { VirtualStoreService } from 'src/app/services/virtual-store.service';
import { AuthService } from 'src/app/core/services/auth.service';
import { OrderItemInsertRequest } from 'src/app/models/virtual-store/order-item-insert-request.model';
import { LoginComponent } from '../../login/login.component';
import { MatDialog } from '@angular/material';
import Swal from 'sweetalert2';
import { Account } from 'src/app/models/account.model';
import { OrderItemService } from 'src/app/services/order-item.service';
import { CommonService } from 'src/app/services/common.service';
import { Subscription } from 'rxjs';
import { OrderItemUpdateRequest } from 'src/app/models/virtual-store/order-item-update-request.model';
import { PopupServiceListComponent } from '../../modals/popup-service-list/popup-service-list.component';
import { AppConstant } from 'src/app/constants/app.constant';
import { MasterTableService } from 'src/app/services/master-table.service';
declare var fbq: Function;
declare var gtag: Function;
@Component({
  selector: 'app-product',
  templateUrl: './product.component.html',
  styleUrls: ['./product.component.scss']
})
export class ProductComponent implements OnInit {
  isClient: boolean;
  productCount: number = 1;
  account: Account;
  /*Suscripción a observable de cuenta seleccionada */
  accountSelectedSubscription: Subscription;

  @Input() products: Product[] = [];
  @Input() viewType: string;
  isCreditLineFnb:boolean;
  codeFilterFnb:string=AppConstant.FNB;  
  plazoAnniosCuotaFnb:number=AppConstant.PlazoAnnios;

  isMensajeIncIgv: boolean= false;
  isMensajeIncIgvFnb: boolean= false;
  constructor(private commonService: CommonService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private virtualStoreService: VirtualStoreService,
    private authService: AuthService,
    private matDialog: MatDialog,
    private orderItemService: OrderItemService,
    private masterTable: MasterTableService) {
      
      this.accountSelectedSubscription = this.commonService.accountSelectedAnnounced.subscribe(account => {
        this.account = account;
        this.isCreditLineFnb= this.authService.getCreditLineFNB().isCreditLineFNB;
      });
    }

  ngOnInit() {
    this.isClient = !this.authService.IsStandaloneModule();  
    this.masterTable.GetDetailsByKey('GASEODOMESTICO_INCLUYE_IGV').subscribe(res => {
      console.log(res.data);
      console.log(res.data.value === '1');
      this.isMensajeIncIgv = res.data.value === '1';
    });
    this.masterTable.GetDetailsByKey('FNB_INCLUYE_IGV').subscribe(res => {
      console.log(res.data);
      console.log(res.data.value === '1');
      this.isMensajeIncIgvFnb = res.data.value === '1';
    });
  }
  goToDetails(product: Product) {   
    this.virtualStoreService.sendProductFromCatalogPacket(product);
    this.router.navigate(['producto'], { relativeTo: this.activatedRoute });
    fbq('track', 'ViewContent');
    localStorage.setItem('_showingDetail', 'true');
  }
  getMainImage(product: Product) {
    if (product.imageList && product.imageList.filter(x => x.isMain).length > 0) {
      return product.imageList.find(x => x.isMain).source;
    } else { return null; }
  }

  onResize(event:Event) {
    this.viewType = (event.target['innerWidth'] < 992) ? this.viewType = 'list' : this.viewType = 'grid'
  }

  addToShoppingCart($event: any, product: Product) {
    
    if (this.isClient) {
      const orderItem = new OrderItemInsertRequest();
      orderItem.productId = product.id;
      orderItem.count = this.productCount;
      orderItem.clientCode = this.account.clientCode;
      orderItem.monthlyPaymentCount = 1; 
      orderItem.documentNumber=this.authService.getBasicData().documentNumber;
      orderItem.documentType=this.authService.getBasicData().documentType;     
      
      this.orderItemService.addPendingOne(orderItem).subscribe(response => {
        if (response.valid) {
          this.virtualStoreService.announceCreditLineUpdated(response.data.creditLine)          
          this.virtualStoreService.announceOrderUpdated(response.data.pendingOrderItemList);

          const pedido = response.data.pendingOrderItemList.filter( x => x.product.id === product.id);

          if(pedido.length > 0)
          {
            product.orderItemId = pedido[0].id;
          }

          if(product.serviceList.length > 0 && !this.isCreditLineFnb)
          {
            this.virtualStoreService.listRelatedServicesCart(product.id).subscribe(responseServices => {

              if(responseServices.valid)
              {
                this.matDialog.open(PopupServiceListComponent, {
                  width: '750px',
                  disableClose: true,
                  data: {
                    serviceList: responseServices.data,
                    clientCode: this.account.clientCode,
                    product: product
                  }
                });
              }
              
            })
          }                             
        } else if (!response.valid && response.warning) {
          Swal.fire('Información', response.message, 'warning')
          this.virtualStoreService.announceCreditLineUpdated(response.data.creditLine)
          this.virtualStoreService.announceOrderUpdated(response.data.pendingOrderItemList);
        }
      })

    } else {
      this.openLoginModal($event,product);
    }
    gtag('event', 'AddToCart');
    fbq('track', 'AddToCart');
  }

  openLoginModal($event: any, product: Product) {
    this.matDialog.open(LoginComponent, {
      data: {
        productId: product.id,
        productCount: this.productCount,
        monthlyPaymentMode: product.monthlyPaymentModeList[0],
        clientY: $event.clientY
      },
      position: {
        top: ($event.clientY - 250)+'px'
      }
    });
  }

  itemCountChanged($event: any, product: Product) {
    const basicItem = new OrderItemUpdateRequest();
    basicItem.id = product.orderItemId;
    basicItem.clientCode = this.account.clientCode;
    basicItem.count = product.count;
    basicItem.monthlyPaymentCount = 1;
    basicItem.isFnb=false;
    this.orderItemService.updatePendingOne(basicItem).subscribe(response => {
      if (response.valid) {
        this.virtualStoreService.announceCreditLineUpdated(response.data.creditLine)
        this.virtualStoreService.announceOrderUpdated(response.data.pendingOrderItemList);
      } else if (!response.valid && response.warning) {
        product.count = $event.previousValue;
        Swal.fire('Información', response.message, 'warning')
        this.virtualStoreService.announceCreditLineUpdated(response.data.creditLine)
        this.virtualStoreService.announceOrderUpdated(response.data.pendingOrderItemList);
      } else {
        product.count = $event.previousValue;
      }
    })
  }
}
